class NavDrawerComponent extends HTMLElement {
  connectedCallback() {
    this.container = this.querySelector('.nav-drawer__container');
    this.overlay = this.querySelector('.nav-drawer__overlay');
    this.trigger = this.querySelector('.nav-drawer__button-show');

    this.trigger?.addEventListener('click', () => this.open());

    this.querySelectorAll('.nav-drawer__close, .nav-drawer__overlay').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });

    // Toggle button fills the dead-space in the row — clicking it toggles the accordion
    this.querySelectorAll('.nav-drawer__toggle').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleSubmenu(btn.closest('.nav-drawer__item'));
      });
    });

    // All nav links close the drawer before navigating
    this.querySelectorAll('.nav-drawer__item-link, .nav-drawer__sublink').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const href = link.getAttribute('href');
        this.close();
        const onEnd = (ev) => {
          if (ev.propertyName !== 'transform') return;
          this.container.removeEventListener('transitionend', onEnd);
          window.location.href = href;
        };
        this.container.addEventListener('transitionend', onEnd);
      });
    });
  }

  open() {
    // Close filter drawer if open
    const filterContainer = document.querySelector('.facets__container.active');
    if (filterContainer) {
      filterContainer.classList.remove('active');
      document.querySelector('.facets__container__overlay.active')?.classList.remove('active');
    }

    this.container.setAttribute('data-cb-drawer-ready', '');
    this.container.classList.add('active');
    this.overlay.classList.add('active');
    this.trigger?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.container.classList.remove('active');
    this.overlay.classList.remove('active');
    this.trigger?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden');
  }

  toggleSubmenu(item) {
    const submenu = item?.querySelector('.nav-drawer__submenu');
    if (!submenu) return;

    const btn = item.querySelector('.nav-drawer__toggle');
    const isOpen = !submenu.hidden;
    submenu.hidden = isOpen;
    btn?.classList.toggle('nav-drawer__toggle--open', !isOpen);
    btn?.setAttribute('aria-expanded', String(!isOpen));
  }
}

customElements.define('nav-drawer-component', NavDrawerComponent);


(() => {
  let dispose;

  function initStickyBar() {
    const buttonsRow = document.querySelector('.facets__mobile-buttons-row');
    if (!buttonsRow) return;

    const header = document.querySelector('.shopify-section-header');
    const isCollection = document.body.classList.contains('body-template-collection');
    const mobile = window.matchMedia('(max-width: 989px)');
    const stickyBar = document.createElement('div');
    stickyBar.className = 'facets__sticky-bar';
    stickyBar.setAttribute('aria-hidden', 'true');
    stickyBar.inert = true;

    const selectors = ['.facets__button-show', '.nav-drawer__button-show'];
    const sources = [];
    selectors.forEach((selector) => {
      const source = buttonsRow.querySelector(selector);
      if (!source) return;
      const proxy = document.createElement('button');
      proxy.type = 'button';
      proxy.className = source.className;
      proxy.innerHTML = source.innerHTML;
      proxy.addEventListener('click', () => buttonsRow.querySelector(selector)?.click());
      stickyBar.appendChild(proxy);
      sources.push({ selector, proxy });
    });
    if (!sources.length) return;
    document.body.appendChild(stickyBar);

    let pastRow = false;
    let footerVisible = false;
    let rowObserver;
    let headerHeight = -1;

    function sync() {
      const visible = pastRow && !footerVisible;
      stickyBar.classList.toggle('facets__sticky-bar--visible', visible);
      stickyBar.setAttribute('aria-hidden', String(!visible));
      stickyBar.inert = !visible;
    }

    function observeRow() {
      const offset = isCollection && mobile.matches && header
        ? header.getBoundingClientRect().height : 0;
      if (offset === headerHeight && rowObserver) return;
      headerHeight = offset;
      rowObserver?.disconnect();
      rowObserver = new IntersectionObserver(([entry]) => {
        pastRow = isCollection
          ? entry.boundingClientRect.top < offset
          : !entry.isIntersecting;
        sync();
      }, { rootMargin: `-${offset}px 0px 0px 0px`, threshold: [0, 1] });
      rowObserver.observe(buttonsRow);
    }

    const resizeObserver = new ResizeObserver(observeRow);
    if (header) resizeObserver.observe(header);
    mobile.addEventListener('change', observeRow);
    observeRow();

    const footer = document.querySelector('.footer');
    const footerObserver = new IntersectionObserver(([entry]) => {
      footerVisible = entry.isIntersecting;
      sync();
    });
    if (footer) footerObserver.observe(footer);

    const buttonObserver = new MutationObserver(() => {
      sources.forEach(({ selector, proxy }) => {
        const source = buttonsRow.querySelector(selector);
        if (source && proxy.innerHTML !== source.innerHTML) proxy.innerHTML = source.innerHTML;
      });
    });
    buttonObserver.observe(buttonsRow, { childList: true, subtree: true, characterData: true });

    return () => {
      rowObserver?.disconnect();
      resizeObserver.disconnect();
      footerObserver.disconnect();
      buttonObserver.disconnect();
      mobile.removeEventListener('change', observeRow);
      stickyBar.remove();
    };
  }

  function refresh() {
    dispose?.();
    dispose = initStickyBar();
  }
  refresh();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', (event) => {
    if (!event.target.querySelector('.facets__mobile-buttons-row')) return;
    dispose?.();
    dispose = undefined;
  });
})();
